import { getConfig } from '../Config/ApplicationConfig';
import { getExecutor } from '../Shared/HttpRequestExecutor';
export var getPaymentSchemes = function (config, code, filter) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).postCancellable("api/v1/product-packs/" + code + "/payment-schemes", config, filter);
};
export var getPaymentSchemeDetails = function (config, code, filter) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).postCancellable("api/v1/product-packs/" + code + "/payment-schemes/details", config, filter);
};
export var getApprovedIndications = function (config, pbsDetailCode) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).getCancellable("api/v1/product-packs/approved-indications/" + pbsDetailCode, config);
};
